import 'owl.carousel'
import 'magnific-popup'

document.addEventListener('DOMContentLoaded', function() {
    let rtl = $('html').attr('dir') === 'rtl';
    $('.gallery').owlCarousel({
        rtl: rtl,
        center: true,
        margin: 20,
        items: 3,
        dots: false,
        loop: true,
        nav: true,
        navText : ["<div class='tparrows tp-leftarrow'></div>","<div class='tparrows tp-rightarrow'></div>"],
        responsive:{
            0:{
                items:1,
                stagePadding: 10,
            },
            554:{
                items:1,
                stagePadding: 50,
                dots: true,
                nav: false
            },
            992:{
                items:1,
                stagePadding: 100,
            },
            1200:{
                items:1,
                stagePadding: 300,
            },
            1400:{
                items:1,
                stagePadding: 350,
            },
        }
    });
    $('.popup-image').magnificPopup({
        disableOn: 700,
        type: 'image',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        gallery: {
            enabled: true,
            tPrev: 'Précedent',
            tNext: 'Suivant',
            tCounter: ''
        },
    });

    $('.projects').owlCarousel({
        rtl: rtl,
        margin: 40,
        items: 3,
        dots: true,
        stagePadding: 0,
        loop: true,
        nav: true,
        navText : ["<span class='long-arrow is-triangle arrow-bar is-left'></span>","<i class='long-arrow is-triangle arrow-bar is-right'></i>"],
        responsive:{
            0:{
                items:1,
            },
            992:{
                items:2,
            },
            1200:{
                items:3,
                margin: 20,
            },
            1401:{
                items:3,
            }
        }
    });
});
